import { useState } from 'react';

import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { useApiContext } from 'context/ApiContext';
import { useShowError } from 'hooks/useShowError';
import { useActionMenu } from 'pages/compra/pedido-realizado/contexts';
import { getSuccessMessage, SuccessMessageProps } from 'util/success';

export function PedidoRealizadoDeleteBtn() {
    const { row, disabledActions, setDisabledActions, setOpenConfirmModal, setDataConfirmModal } = useActionMenu();
    const [isDeleting, setIsDeleting] = useState<boolean>(false);
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();
    const { showError } = useShowError();
    const { api } = useApiContext();
    const { idPedido } = row;

    const handleDelete = () => {
        setDisabledActions(true);
        setIsDeleting(true);

        if (idPedido) {
            api.delete(`/compra/pedidocompra/${idPedido}`)
                .then((result: SuccessMessageProps) => {
                    const message = getSuccessMessage(result);

                    enqueueSnackbar(message, { variant: 'success' });

                    queryClient.invalidateQueries(['getListPedidosRealizados']).finally(() => setDisabledActions(false));

                    setIsDeleting(false);
                })
                .catch((error) => {
                    setIsDeleting(false);

                    setDisabledActions(false);

                    showError(error, 'Não foi possível cancelar o pedido. Tente novamente');
                });
        }
    };

    return (
        <Button
            color="inherit"
            startIcon={<DeleteOutlinedIcon />}
            loading={isDeleting}
            disabled={disabledActions}
            onClick={() => {
                setOpenConfirmModal(true);

                setDataConfirmModal({ callback: handleDelete });
            }}
        >
            Excluir
        </Button>
    );
}
